let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aS4l7")).then(() => parcelRequire('kGKHk'));